import React, { useState, useEffect } from "react";
import { backend } from "../../../api";
import { toast } from "react-toastify";
import { Skeleton } from "@material-ui/lab";
import {
  makeStyles,
  Box,
  Button,
  FormControl,
  Select,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { editPrice } from "../../../redux-store/books/actions";

const useStyles = makeStyles((theme) => ({
  root: {
    borderTop: `1px solid ${theme.palette.secondary.dark}`,
    margin: "20px 0",
  },
  sectionHeading: {
    fontSize: 20,
    fontWeight: 500,
    color: theme.palette.primary.dark,
  },
  button: {
    justifyContent: "end",
  },
}));

const Category = (props) => {
  const classes = useStyles();
  const { bookId, currentBook } = props;

  const dispatch = useDispatch();
  const [bookCategory, setBookCategory] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [categoryOptions, setCategoryOption] = useState([]);

  const handleUpdateCategory = () => {
    const updatedCategory = {
      book_category: bookCategory,
    };
    dispatch(editPrice(updatedCategory, bookId));

    setEditMode(false);
  };

  useEffect(() => {
    if (currentBook) {
      setBookCategory(currentBook.book_category.category_name);
    }
    fetchCategory();
  }, [currentBook]);

  const fetchCategory = () => {
    backend
      .get("/category")
      .then((res) => {
        if (res.data.message === "Book Category Found Successfully") {
          setCategoryOption(res.data.data);
        }
      })
      .catch((err) => {
        toast.error(err.response ? err.response.data.message : err.message);
      });
  };

  const changeBookCategory = (e) => {
    setBookCategory(e.target.value);
  };

  return (
    <div className={classes.root}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <h2 className={classes.sectionHeading}>Category</h2>
        {editMode ? (
          <div className={classes.button}>
            <Button variant="outlined" onClick={handleUpdateCategory}>
              Update
            </Button>
            <Button
              style={{ marginLeft: "3px" }}
              variant="outlined"
              color="secondary"
              onClick={() => setEditMode(false)}
            >
              Cancel
            </Button>
          </div>
        ) : (
          <Button variant="outlined" onClick={() => setEditMode(true)}>
            Edit
          </Button>
        )}
      </Box>
      {currentBook ? (
        <Box my={1}>
          {editMode ? (
            <FormControl variant="outlined" fullWidth style={{ padding: 5 }}>
              <Select
                native
                value={bookCategory}
                onChange={changeBookCategory}
              >
                {categoryOptions.map((item) => (
                  <option key={item.category_name} value={item.category_name}>
                    {item.category_name}
                  </option>
                ))}
              </Select>
            </FormControl>
          ) : (
            <p>
              {currentBook.book_category
                ? currentBook.book_category.category_name
                : "Uncategorized"}
            </p>
          )}
        </Box>
      ) : (
        <Skeleton animation="wave" width="100%" height={50} />
      )}
    </div>
  );
};

export default Category;
